import React from 'react';
import {
	rescheduleCall,
	setCancelReason,
} from '../../redux/myCourse/myCourse.actions';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/Button';

const CancelFeedback = ({ setCancelReason, rescheduleCall, cancelReason }) => {
	return (
		<div class="modal" tabindex="-1" id="cancelCall" role="dialog" data-backdrop="false">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header">
					<h4 className="modal-title">Reason for cancellation:</h4>
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>

					</div>
					<div class="modal-body">
						<textarea
							className="form-control"
							value={cancelReason}
							onChange={setCancelReason}
							rows="5"
							placeholder="Type your reason here."
							required
						></textarea>
						<br />
						<div className="form-group text-right">
							<Button
								aria-label="submit"
								className="btn  btn-primary go-next"
								onClick={rescheduleCall}
							>
								Submit
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		cancelReason: state.rootReducer.myCourse.cancelReason,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		rescheduleCall: () => dispatch(rescheduleCall()),
		setCancelReason: (e) => dispatch(setCancelReason(e.target.value)),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(CancelFeedback);
